import React, { useEffect, useState } from "react";
import FaqForm from "./FaqForm";
import "./faq.css";

import {
 fetchAllFaqs,
 deleteFaq as deleteFaqService
} from "./adminFaqService";

const AdminFaqPage = () => {

 const [faqs, setFaqs] = useState([]);
 const [editing, setEditing] = useState(null);
 const [showForm, setShowForm] = useState(false);
 const [loading, setLoading] = useState(false);

 useEffect(() => {
 loadFaqs();
 }, []);

 /**
 * Load all FAQs
 */
 const loadFaqs = async () => {

 setLoading(true);

 const response = await fetchAllFaqs();

 if (response.status === 200) {
 setFaqs(response.data);
 } else {
 alert(response.message || "Failed to load FAQs");
 }

 setLoading(false);

 };

 /**
 * Delete FAQ
 */
 const deleteFaq = async (id) => {

 if (!window.confirm("Delete this FAQ?")) return;

 const response = await deleteFaqService(id);

 if (response.status === 200 || response.status === 204) {

 loadFaqs();

 } else {

 alert(response.message || "Delete failed");

 }

 };

 /**
 * Edit FAQ
 */
 const editFaq = (faq) => {

 setEditing(faq);
 setShowForm(true);

 };

 /**
 * Create new FAQ
 */
 const newFaq = () => {

 setEditing(null);
 setShowForm(true);

 };

 /**
 * After save refresh list
 */
 const onFormSaved = () => {

 setShowForm(false);
 loadFaqs();

 };

 return (

 <div className="admin-container">

 <div className="admin-header">

 <h2>FAQ Management</h2>

 <button onClick={newFaq}>
 + New FAQ
 </button>

 </div>

 {showForm && (

 <FaqForm
 faq={editing}
 onSaved={onFormSaved}
 onCancel={() => setShowForm(false)}
 />

 )}

 {loading ? (

 <p>Loading FAQs...</p>

 ) : (

 <table className="faq-table">

 <thead>

 <tr>
 <th>Question</th>
 <th>Answer</th>
 <th>YouTube Link</th>
 <th>Actions</th>
 </tr>

 </thead>

 <tbody>

 {faqs.length === 0 ? (

 <tr>
 <td colSpan="4">
 No FAQs found
 </td>
 </tr>

 ) : (

 faqs.map((faq) => (

 <tr key={faq.id}>

 <td className="faq-question-cell">
 {faq.question}
 </td>

 <td className="faq-answer-cell">
 {faq.answer}
 </td>

 <td className="faq-link-cell">
 {faq.youtubeVideoLink ? (
 <a
 href={faq.youtubeVideoLink}
 target="_blank"
 rel="noreferrer"
 >
 Open Link
 </a>
 ) : (
 "-"
 )}
 </td>

 <td>

 <button
 onClick={() => editFaq(faq)}
 >
 Edit
 </button>

 <button
 className="delete-btn"
 onClick={() => deleteFaq(faq.id)}
 >
 Delete
 </button>

 </td>

 </tr>

 ))

 )}

 </tbody>

 </table>

 )}

 </div>

 );

};

export default AdminFaqPage;